import { api } from '@/lib/api';
import type {
  EosTodo,
  EosTodoFilters,
  EosTodoListResponse,
  CreateEosTodoInput,
  UpdateEosTodoInput,
} from './types';

function toQuery(filters?: EosTodoFilters): Record<string, string | number | undefined> {
  if (!filters) return {};
  const q: Record<string, string | number | undefined> = { ...filters } as never;
  if (filters.include_completed !== undefined) q.include_completed = String(filters.include_completed);
  if (filters.include_cancelled !== undefined) q.include_cancelled = String(filters.include_cancelled);
  if (filters.owner_ids?.length) {
    q.ownerIds = filters.owner_ids.join(',');
    delete (q as Record<string, unknown>).owner_ids;
  }
  return q;
}

export const listEosTodos = (filters?: EosTodoFilters) =>
  api.get<EosTodoListResponse>('/v4/eos-todos', toQuery(filters));

export const getEosTodo = (id: string) =>
  api.get<EosTodo>(`/v4/eos-todos/${id}`);

export const createEosTodo = (data: CreateEosTodoInput) =>
  api.post<EosTodo>('/v4/eos-todos', data);

export const updateEosTodo = (id: string, data: UpdateEosTodoInput) =>
  api.patch<EosTodo>(`/v4/eos-todos/${id}`, data);

export const completeEosTodo = (id: string) =>
  api.post<EosTodo>(`/v4/eos-todos/${id}/complete`, {});

export const reopenEosTodo = (id: string) =>
  api.post<EosTodo>(`/v4/eos-todos/${id}/reopen`, {});

export const cancelEosTodo = (id: string) =>
  api.post<EosTodo>(`/v4/eos-todos/${id}/cancel`, {});

export const deleteEosTodo = (id: string) =>
  api.delete(`/v4/eos-todos/${id}`);
